export default __webpack_public_path__ + "static/video-1-poster-b7349efcbe4f3781c27f90cd1b047cf0.png";